"use client";

import { c as _c } from "react/compiler-runtime";
import { useBreakpoint } from "@dc/hooks";
import { Button } from "@dc/ui/components";
import { useTranslations } from "next-intl";
import type { FC } from "react";
import type { OrganizationSwitchError } from "@/app/providers/EmsEntitlementGate/hooks/useEmsEntitlementGate/useEmsEntitlementGate";
import { ErrorPageContent } from "@/components/ErrorPageContent/ErrorPageContent";
import { OrgSwitcher } from "@/components/OrgSwitcher/OrgSwitcher";
import { useOrganization } from "@/hooks/useOrganization";
import { useEmsNotEntitledPage } from "./hooks/useEmsNotEntitledPage/useEmsNotEntitledPage";
export interface EmsNotEntitledPageProps {
  /** Handles navigating into the newly picked org once selected — owned by EmsEntitlementGate, since it must survive this page unmounting mid-switch. */
  onOrganizationSelected: (organizationId: string) => void;
  /** Set when the last org switch attempt couldn't land anywhere (e.g. the org has no accessible teams). */
  organizationSwitchError?: OrganizationSwitchError | null;
}
export const EmsNotEntitledPage: FC<EmsNotEntitledPageProps> = t0 => {
  const $ = _c(28);
  const {
    onOrganizationSelected,
    organizationSwitchError
  } = t0;
  const {
    organizations,
    currentOrganization
  } = useOrganization();
  const {
    handleSignOut,
    isLoggingOut
  } = useEmsNotEntitledPage();
  const t = useTranslations("ems_entitlement");
  const isMobile = !useBreakpoint("sm");
  const hasMultipleOrgs = organizations.length > 1;
  let T0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== currentOrganization?.attributes?.name || $[1] !== t) {
    const orgName = currentOrganization?.attributes?.name ?? t("fallback_organization_name");
    t3 = "flex h-dvh w-dvw flex-col items-center justify-center gap-4 bg-background";
    T0 = ErrorPageContent;
    t1 = "APP_ERROR";
    t2 = t("title", {
      orgName
    });
    $[0] = currentOrganization?.attributes?.name;
    $[1] = t;
    $[2] = T0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    T0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("description");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== handleSignOut || $[9] !== hasMultipleOrgs || $[10] !== isLoggingOut || $[11] !== isMobile || $[12] !== onOrganizationSelected || $[13] !== t) {
    t5 = hasMultipleOrgs ? {
      node: <OrgSwitcher trigger={<Button variant="bordered" color="primary" className="gap-2" size={isMobile ? "lg" : "md"}>{t("switch_organization")}</Button>} onOrganizationSelected={onOrganizationSelected} />
    } : {
      label: t("sign_out"),
      onClick: handleSignOut,
      isLoading: isLoggingOut
    };
    $[8] = handleSignOut;
    $[9] = hasMultipleOrgs;
    $[10] = isLoggingOut;
    $[11] = isMobile;
    $[12] = onOrganizationSelected;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== T0 || $[16] !== t1 || $[17] !== t2 || $[18] !== t4 || $[19] !== t5) {
    t6 = <T0 errorCode={t1} title={t2} description={t4} action={t5} />;
    $[15] = T0;
    $[16] = t1;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== organizationSwitchError || $[22] !== t) {
    t7 = organizationSwitchError === "no_accessible_teams" && <p className="text-danger text-sm">{t("no_accessible_teams")}</p>;
    $[21] = organizationSwitchError;
    $[22] = t;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t3 || $[25] !== t6 || $[26] !== t7) {
    t8 = <div className={t3}>{t6}{t7}</div>;
    $[24] = t3;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};